export default "__VITE_ASSET__C_mC0HhD__"